// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'bootstrap/dist/js/bootstrap';

import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import VueCurrencyFilter from 'vue-currency-filter';
import VueMoment from 'vue-moment';
import moment from 'moment';
import VueTheMask from 'vue-the-mask';
import money from 'v-money';
import Notify from 'vue2-notify'; // https://github.com/websmurf/vue2-notify
import Loading from 'vue-loading-overlay'; // https://github.com/ankurk91/vue-loading-overlay
import 'vue-loading-overlay/dist/vue-loading.min.css';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';

import 'bootstrap-vue/dist/bootstrap-vue.css';
// import VueNotifications from 'vue-notifications'
// import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr

//  new Logo



// GLOBAL COMPONENTS
import NewLogo from './parts/components/newLogo'
import Page from './parts/components/page';
import Header from './parts/components/header';
import Button from './parts/components/button';
import Link from './parts/components/link';
import Card from './parts/components/card';
import Logo from './parts/components/logo';
import Text from './parts/components/text';
import Input from './parts/components/input';
import Divider from './parts/components/divider';
import Icon from './parts/components/icon';
import Image from './parts/components/image';
import Avatar from './parts/components/avatar';
import Badge from './parts/components/badge';
import Modal from './parts/components/modal';
import Breadcrumb from './parts/components/breadcrumb';
import Dropdown from './parts/components/dropdown';
import Rate from './parts/components/rate';
import List from './parts/components/list';
import Item from './parts/components/item';
import Stars from './parts/components/stars';
import Tabs from './parts/components/tabs';
import Alert from './parts/components/alert';
import Progress from './parts/components/progress';
import Loader from './parts/components/loader';
import Accordion from './parts/components/accordion';
import Helper from './parts/components/helper';
import Chip from './parts/components/chip';
import RatingModal from './parts/modals/rating-modal';
import AnnouncementModal from './parts/modals/announcement-modal';
import login from './parts/components/login'
// GLOBAL LAYOUT
import Row from './parts/layout/row';
import Col from './parts/layout/col';
import Container from './parts/layout/container';
import Inner from './parts/layout/inner';
import Div from './parts/layout/div';
import Content from './parts/layout/content';

// GLOBAL MODULES
import Topbar from './parts/modules/topbar';
import Modals from './parts/modules/modals';

import { eventHub } from '@/utils/eventhub';

// GLOBAL COMPONENTS
Vue.component('v-login', login )
Vue.component('v-header', Header)
Vue.component('v-page', Page);
Vue.component('v-button', Button);
Vue.component('v-link', Link);
Vue.component('v-card', Card);
Vue.component('v-logo', Logo);
Vue.component('v-NewLogo', NewLogo);
Vue.component('v-text', Text);
Vue.component('v-input', Input);
Vue.component('v-divider', Divider);
Vue.component('v-icon', Icon);
Vue.component('v-image', Image);
Vue.component('v-avatar', Avatar);
Vue.component('v-badge', Badge);
Vue.component('v-modal', Modal);
Vue.component('v-breadcrumb', Breadcrumb);
Vue.component('v-dropdown', Dropdown);
Vue.component('v-rate', Rate);
Vue.component('v-list', List);
Vue.component('v-item', Item);
Vue.component('v-stars', Stars);
Vue.component('v-tabs', Tabs);
Vue.component('v-alert', Alert);
Vue.component('v-progress', Progress);
Vue.component('v-loader', Loader);
Vue.component('v-accordion', Accordion);
Vue.component('v-helper', Helper);
Vue.component('v-chip', Chip);
Vue.component('v-rating-modal', RatingModal);
Vue.component('v-announcement-modal', AnnouncementModal);
// GLOBAL LAYOUT
Vue.component('v-row', Row);
Vue.component('v-col', Col);
Vue.component('v-container', Container);
Vue.component('v-inner', Inner);
Vue.component('v-div', Div);
Vue.component('v-content', Content);
// GLOBAL MODULES
Vue.component('v-topbar', Topbar);
Vue.component('v-modals', Modals);

Vue.config.productionTip = false;

// miniToastr.init()

// function toast({ title, message, type, timeout, cb }) {
//  return miniToastr[type](message, title, timeout, cb)
// }

// const options = {
// success: toast,
// error: toast,
// info: toast,
// warn: toast
// }

// Vue.use(VueNotifications, options)

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Notify, { visibility: 10000 });
Vue.use(Loading);

Vue.use(VueMoment, { moment });
Vue.use(VueTheMask);
Vue.use(money, {
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  precision: 2,
  masked: false,
});

Vue.use(VueCurrencyFilter, {
  symbol: 'R$',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true,
  masked: false,
});

Vue.filter('cel_phone', value => {
  if (!value) return '';
  return value
    .replace(/[^0-9]/g, '')
    .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
});

// Sentry configuration wrapper
const SentryConfig = {
  init() {
    if (process.env.NODE_ENV === 'production') {
      Raven
        .config('https://96fcc53936144bd6bc32d0750f2c1544@sentry.io/1280596', {
          release: process.env.VERSION,
          environment: process.env.NODE_ENV
        })
        .addPlugin(RavenVue, Vue)
        .install();
    } else {
      console.log('Sentry disabled in development mode');
    }
  },
  
  // Proxy methods for consistent usage
  captureException(error) {
    if (process.env.NODE_ENV === 'production') {
      Raven.captureException(error);
    } else {
      console.error('Sentry (dev) Exception:', error);
    }
  },
  
  captureMessage(message) {
    if (process.env.NODE_ENV === 'production') {
      Raven.captureMessage(message);
    } else {
      console.log('Sentry (dev) Message:', message);
    }
  }
};

// Initialize Sentry configuration
SentryConfig.init();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  created() {
    Vue.prototype.$currency = function(n) {
      return Number(n)
        .toFixed(2)
        .replace('.', ',')
        .replace(/(\d)(?=(\d{3})+\,)/g, '$1.');
    };
    Vue.prototype.$app = {
      profile: {
        id: 'vibbrant',
        label: 'Vibbrates',
      },
      data: {
        uf: [
          'AC',
          'AL',
          'AM',
          'AP',
          'BA',
          'CE',
          'DF',
          'ES',
          'GO',
          'MA',
          'MT',
          'MS',
          'MG',
          'PA',
          'PB',
          'PR',
          'PE',
          'PI',
          'RJ',
          'RN',
          'RO',
          'RS',
          'RR',
          'SC',
          'SE',
          'SP',
          'TO',
        ],
      },
    };
  },
});



// WEBPACK FOOTER //
// ./src/main.js